import { SwiperScreenSizes } from '@interfaces';

export const BREAKPOINTS = {
  [SwiperScreenSizes.Mobile1]: {
    slidesPerView: 2,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.Mobile3]: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.Tablet]: {
    slidesPerView: 3,
    spaceBetween: 10,
  },
  [SwiperScreenSizes.TabletHorizontal]: {
    slidesPerView: 4,
    spaceBetween: 16,
  },
};
